<div
  class="z-[2] px-xs flex justify-between mdUp:text-mmd font-bold items-center"
>
  <div class="rounded-lg text-white bd-white px-xs py-[5px]">
    <a href="wallet">Recharge</a>
  </div>
</div>
